<template>
  <Modal v-model="platformOrderLogDetailsModal" :title="$t('key1005995')" width="1000" :transfer="false" :mask-closable="true">
    <h2 class="font-size-14 font-weight-bold mb8">{{ $t('key1005996') }}</h2>
    <Table
      border
      max-height="300"
      :loading="tableLoading"
      :columns="tableColumns"
      :data="beforeAdjustmentData">
    </Table>
    <h2 class="font-size-14 font-weight-bold mt25 mb8">{{ $t('key1005997') }}</h2>
    <Table
      border
      max-height="300"
      :loading="tableLoading"
      :columns="tableColumns"
      :data="afterAdjustmentData">
    </Table>
    <template #footer>
      <Button class="mr15" type="primary" @click="platformOrderLogDetailsModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {isJSON, batchAllWarehouseData, getAllMatchingLogisticsData} from "@/utils/common";

export default {
  name: 'platformOrderLogDetailsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      platformOrderLogDetailsModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'),
          key: 'packageCode',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let skusList = params.row.skus || [];
            if (skusList.length > 0) {
              return h('span', {style: {whiteSpace: 'pre-line'}}, skusList.join('\n'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'shippingWarehouseName',
          minWidth: 150,
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581'),
          key: 'logisticsName',
          minWidth: 200,
          align: 'left'
        },
      ],
      beforeAdjustmentData: [], // 调整前
      afterAdjustmentData: [], // 调整后
    };
  },
  methods: {
    async initPackageList(packageList) {
      if (!packageList || packageList.length === 0) return [];
      const ymsWarehouseIds = packageList.map(item => item.ymsWarehouseId).filter(Boolean);
      if (ymsWarehouseIds.length === 0) return packageList;
      const warehouseData = await batchAllWarehouseData(ymsWarehouseIds);
      const warehouseMap = {};
      warehouseData.forEach(w => {
        warehouseMap[w.ymsWarehouseId] = w.name;
      });
      const matchingLogisticsData = await getAllMatchingLogisticsData({warehouseIds: ymsWarehouseIds});
      packageList.forEach(ele => {
        ele.shippingWarehouseName = warehouseMap[ele.ymsWarehouseId] || '';
        const j = matchingLogisticsData.find(j => j.ymsWarehouseId === ele.ymsWarehouseId);
        if (j && j.logisticsData) {
          j.logisticsData.forEach(talg => {
            talg.list.forEach(k => {
              if (ele.ymsLogisServiceId && k.ymsLogisServiceId === ele.ymsLogisServiceId) {
                ele.logisticsName = k.name;
              } else if (!ele.ymsLogisServiceId && ele.carrierId && ele.shippingMethodId) {
                if (
                  (k.carrierId === ele.carrierId && k.shippingMethodId === ele.shippingMethodId) ||
                  (k.coreCarrierId === ele.carrierId && k.coreShippingMethodId === ele.shippingMethodId)
                ) {
                  ele.logisticsName = k.name;
                }
              }
            });
          });
        }
      });
      return packageList;
    },
    async initPlatformOrderLogDetailsData(item) {
      this.beforeAdjustmentData = [];
      this.afterAdjustmentData = [];
      if (!item) return;
      const content = item.content;
      if (!isJSON(content)) return;
      const obj = JSON.parse(content);
      const oldPackage = [obj.oldPackage] || [];
      const newPackage = obj.newPackage || [];
      const processedOld = await this.initPackageList(oldPackage);
      this.beforeAdjustmentData = processedOld;
      const processedNew = await this.initPackageList(newPackage);
      this.afterAdjustmentData = processedNew;
      this.platformOrderLogDetailsModal = true;
    }
  }
};
</script>

<style lang="less">

</style>
